import { RewardPageModuleWrapper } from 'components/features/rewards/rewardPage/RewardPage/RewardPageModuleWrapperPreset'
import { FC, ReactNode } from 'react'
import { RewardsSummary } from 'components/features/rewards/rewardPageSummary/RewardsSummary/RewardsSummary'
import styles from 'components/features/rewards/rewardPageSummary/RewardsSummaryModule/RewardsSummaryModule.styl'

type RewardsSummaryModuleProps = {
  className?: string
  mode?: 'regular' | 'dashboard'
  action?: ReactNode
}
export const RewardsSummaryModule: FC<RewardsSummaryModuleProps> = (props) => {
  const { className, mode = 'regular', action } = props

  return (
    <RewardPageModuleWrapper
      forceRoundedCorners
      withPaddingBottom
      isContentFlexLayout
      isFlexLayout
      title={ mode === 'regular' ? 'Summary' : 'Rewards Summary' }
      corners='all'
      anchor='rewards_summary'
      shadowTheme='regular'
      className={ className }
      cardClassName={ styles.cardBlockSummary }
      action={ action }
    >
      <RewardsSummary />
    </RewardPageModuleWrapper>
  )
}
